import config from '@/config'
import axios from 'axios'
import auth from '@/services/auth'
import utils from '@/helpers/utils/index.js'

import {FORM_CONSTANTS} from '@/components/DataGrid/FormBuilder/config/constants'

export default function (_this) {
  return {
    async create(data) {
      const { name, isTemplate } = data
      const uid = _this.getUserId()
      const dashboard = {
        name: name,
        owner: uid
      }

      if (isTemplate) dashboard.isTemplate = true

      const dashKey = await new Promise((resolve) => {
        let key = _this.dashRef.push(dashboard, () => {
          resolve(key)
        }).key
      })


      if (isTemplate) this.setAsTemplate(dashKey)

      await this.setInitialData(dashKey)

      _this.root
        .ref('dashboardsList')
        .child(dashKey)
        .set(dashboard)

      _this.accessRef
        .child('Dashboard')
        .child(uid + '/' + dashKey).set({
          update: true
        })

      _this.tabs.create({ title: 'Home', dash: dashKey, order: 0 })

      this.setEmailTemplatesPlaceholder(dashKey)

      return dashKey
    },
    setInitialData (dashKey) {
      return new Promise((resolve) => {
        _this.initialDataRef.once('value', (snapshot) => {
          let data = snapshot.val()

          if (data) {
            _this.dashRef.child(dashKey).update(data, () => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },
    setEmailTemplatesPlaceholder (dashKey) {
      _this.root.ref(`emailTemplates/newUserInvite/${dashKey}`)
        .set({
          body: "email body placeholder",
          from: "email_from@placeholder.com",
          subject: "email subject placeholder"
        })
    },
    removeEmailTemplates (dashKey) {
      _this.root.ref(`emailTemplates/newUserInvite/${dashKey}`).remove()
    },
    async delete (dashKey, cb) {
      let uid = _this.getUserId()
      let sharedWith = null
      let dashOwner = null

      await new Promise((resolve) => {
        _this.dashRef.child(dashKey).once('value', (snapshot) => {
          let data = snapshot.val()
          dashOwner = data.owner
          if (data && data.sharedWith) sharedWith = data.sharedWith
          resolve()
        })
      })

      await new Promise((resolve) => {
        if (dashOwner === uid) {
          _this.dashRef.child(dashKey).remove(() => {
            resolve()
          })
        } else {
          _this.dashRef.child(dashKey + '/sharedWith/' + uid).remove(() => {
            resolve()
          })
        }
      })

      await new Promise((resolve) => {
        if (dashOwner === uid) {
          if (sharedWith) {
            for (let sharedUid in sharedWith) {
              _this.accessRef
                .child('Dashboard')
                .child(sharedUid + '/' + dashKey).remove()
            }
          }
          _this.accessRef
            .child('Dashboard')
            .child(uid + '/' + dashKey).remove(() => {
              resolve()
            })
        } else {
          _this.accessRef
            .child('Dashboard')
            .child(uid + '/' + dashKey).remove(() => {
              resolve()
            })
        }
      })

      this.removeEmailTemplates(dashKey)

      if (dashOwner === uid) {
        _this.root
          .ref('dashboardsList')
          .child(dashKey)
          .remove()

        _this.root
          .ref('dashboardsAsTemplate')
          .child(dashKey)
          .remove()
      }

      if (cb) cb()
    },
    edit (key, name) {
      _this.dashRef.child(key + '/name').set(name)
      _this.root.ref('dashboardsList')
        .child(key)
        .child('name')
        .set(name)
    },

    setSlackTeam (key, slackTeam) {
      _this.dashRef.child(key + '/slackTeam').set(slackTeam)
    },

    share (data, callback) {
      let uid = data.uid
      let dash = data.dash

      let promise = new Promise((resolve) => {
        _this.dashRef.child(dash + '/sharedWith/' + uid).set(true, () => {
          resolve()
        })
      })

      promise.then(() => {
        _this.accessRef
          .child('Dashboard')
          .child(uid + '/' + dash).update(data.rules, (err) => {
            if (err) callback(err)
            else callback()
          })
      })
    },
    getOwner (cb) {
      _this.getRef('owner').once('value', (snapshot) => {
        cb(snapshot.val())
      })
    },
    makePublic (dash, setPublic, callback) {
      if (setPublic) {
        _this.root.ref('publicDashboards/' + dash).set(true, () => {
          callback()
        })
      } else {
        _this.root.ref('publicDashboards/' + dash).remove(() => {
          callback()
        })
      }
    },
    isPublic (dash, callback) {
      _this.root.ref('publicDashboards/' + dash).once('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    async read (uid, cb) {
      cb ({})

      const access = await new Promise((resolve) => {
        _this.root.ref('access/Dashboard')
          .child(uid)
          .once(
            'value',
            (snapshot) => (resolve(snapshot.val())),
            (err) => (console.error(err))
          )
      })

      if (access) {
        const dashMeta = await new Promise((resolve) => {
          _this.root.ref('dashboardsList')
            .once(
              'value',
              (snapshot) => (resolve(snapshot.val())),
              (err) => (console.error(err))
            )
        })

        const dashboards = {}

        for (let dashId in access) {
          if (!dashMeta[dashId]) {
            //console.error(`Dashboard "${dashId}" doesn't exist`)
            continue
          }
          dashboards[dashId] = dashMeta[dashId]
        }

        cb(dashboards)
      } else {
        cb({})
      }
    },
    readOne(key) {
      return new Promise(resolve => {
        _this.root.ref('dashboards')
          .child(key)
          .once('value', snapshot => {
            resolve(snapshot.val())
          })
      })
    },
    clearAnonymousData (uid, callback) {
      let promise = new Promise((resolve) => {
        _this.accessRef
          .child('Dashboard')
          .child(uid).once('value', (snapshot) => {
            resolve(snapshot.val())
          })
      })

      promise.then((dashKeys) => {
        if (!dashKeys) callback()
        for (let key in dashKeys) {
          this.delete(key)
        }
        _this.accessRef
          .child('Dashboard')
          .child(uid).remove()
        callback()
      })
    },
    replaceOwner (oldUid, newUid, callback) {
      let promise = new Promise((resolve) => {
        _this.accessRef
          .child('Dashboard')
          .child(oldUid).once('value', (snapshot) => {
            if (!snapshot.val()) resolve()
            else resolve(snapshot.val())
          })
      })

      promise.then((dashKeys) => {
        if (!dashKeys) {
          callback()
        } else {
          _this.accessRef
            .child('Dashboard')
            .child(oldUid).remove()
          _this.accessRef
            .child('Dashboard')
            .child(newUid).set(dashKeys, () => {
              callback()
            })
        }
      })

      promise.then((dashKeys) => {
        if (!dashKeys) return

        for (let key in dashKeys) {
          _this.dashRef.child(key + '/owner').set(newUid)
          _this.root.ref('dashboardsList').child(key + '/owner').set(newUid)
        }
      })
    },
    /**
     * Read all dashboards
     */
    readAll () {
      return new Promise((resolve) => {
        _this.root.ref('dashboardsList').on('value', (snapshot) => {
          resolve(snapshot.val())
        })
      })
    },
    getTitle (cb) {
      _this.getRef('name').on('value', (snapshot) => {
        cb(snapshot.val())
      })
    },
    async getUsers (cb) {
      const owner = await new Promise((resolve) => {
        _this.getRef('owner').once('value', (snapshot) => {
          resolve(snapshot.val())
        })
      })

      _this.getRef('sharedWith').on('value', (snapshot) => {
        const sharedWith = snapshot.val()

        if (!sharedWith) {
          const users = []
          users.push(owner)
          cb(users)
        } else {
          const sharedWithUsers = Object.keys(sharedWith)

          if (sharedWithUsers.includes(owner)) {
            cb(sharedWithUsers)
          } else {
            sharedWithUsers.push(owner)
            cb(sharedWithUsers)
          }
        }
      })
    },
    async fillDashboardFromTemplate (template, dashboard) {
      const functionsUrl = config.midServer[process.env.APP_CONF.instance]
      const idToken = await auth.getIdToken()
      const data = {
        idToken,
        template,
        dashboard
      }

      return axios.post(
        `${functionsUrl}/fillDashboardFromTemplate`,
        JSON.stringify(data)
      )
    },
    async importFromExcel (data, dashKey, keepTabs) {
      const ref = _this.root.ref(`dashboards/${dashKey}`)

      if (!keepTabs) {
        await new Promise((resolve) => {
          ref.child(`tabs`).remove(() => (resolve()))
        })
      }

      for (let idx in data) {
        if (idx === 'rmIndex') continue
        const sheet = data[idx]

        const tabKey = await new Promise((resolve) => {
          const tabData = {
            title: sheet.name,
            dash: dashKey,
            count: idx
          }
          _this.tabs.create(tabData, (key) => (resolve(key)))
        })

        const gridId = utils.sanitize(sheet.name)
        const gridOptions = {
          title: sheet.name,
          storageType: 'dashboard',
          source: gridId,
          tab: tabKey,
          overflow:'height:auto'
        }

        await _this.dataGrid.widget.createNew(gridOptions, ref)

        if (sheet.data.length) {
          for (let columnName in sheet.data[0]) {
            if (columnName === 'rmIndex') continue
            const cellKey = utils.sanitize(columnName)
            const columnData = {
              displayName: columnName,
              propertyName: cellKey,
              gridId,
              type: 'string'
            }

            await this.addTextColumn(columnData, ref)
            await this.addControl(ref, gridId, 'text', cellKey, columnName)
          }

          let tData = {}

          let id = Date.now()

          for (let row of sheet.data) {
            const rData = {}
            for (let columnName in row) {
              rData[utils.sanitize(columnName)] = {
                type: 'string',
                value: row[columnName]
              }
            }

            const rowKey = uuidv1()

            rData.rowKey = rowKey

            tData[rowKey] = rData

            id += 1
          }

          ref.child(`models/${gridId}`).set(tData)
        }
      }
    },
    async addTextColumn (data, ref) {
      function getOptions (gridId, cb) {
        ref.child(`widgetsData/dataGrid/${gridId}`)
          .once('value', (snapshot, err) => {
            if (err) cb(err)
            else cb(null, snapshot.val())
          })
      }

      async function writeMetaForColumn (gridId, propertyName, data) {
        const mdRef = `widgetsData/dataGrid/${gridId}/meta`;

        const mData = await new Promise((resolve) => {
          ref.child(mdRef)
            .once('value', (snapshot) => {
              resolve(snapshot.val() || {})
            }, (err) => {
              console.error(err)
              resolve({})
            })
        })

        if (!data.order) data.order = utils.count(mData)

        mData[propertyName] = data

        if (Object.keys(mData).length === 1) {
          await new Promise((resolve) => {
            ref.child(`widgetsData/dataGrid/${gridId}/displayColumn`)
              .set(propertyName, (err) => {
                if (err) console.error(err)
                resolve()
              })
          })
        }

        await new Promise((resolve) => {
          ref.child(mdRef).set(mData, (err) => {
            if (err) console.error(err)
            resolve()
          })
        })
      }

      const {
        displayName,
        propertyName,
        gridId,
        type
      } = data

      // get options
      let optsErr
      let opts

      await new Promise((resolve) => {
        getOptions(gridId, (err, res) => {
          if (err) {
            optsErr = err
            resolve()
          } else {
            opts = res
            resolve()
          }
        })
      })

      if (optsErr) {
        cb(optsErr)
        return
      }

      const mData = {
        displayName,
        type
      }

      await writeMetaForColumn(gridId, propertyName, mData)
    },
    async addControl(ref, gridId, controlType, propName, colName) {
      const templateFormData = await new Promise((resolve) => {
        ref.child(`widgetsData/dataGrid/${gridId}/rowEditorFieldsForm`)
          .once('value', (snapshot) => (resolve(JSON.parse(snapshot.val()))))
      })

      let controlInfo = _.cloneDeep(FORM_CONSTANTS.Control)
      let controlTypes = _.cloneDeep(FORM_CONSTANTS.Type)
      controlInfo.type = controlType

      // generate id
      controlInfo.name = _.domUniqueID(`control_${controlType}_`)
      controlInfo.label = controlTypes[controlType].label
      controlInfo.fieldName = controlInfo.name // same for both

      // check if there's any more special fields?
      if(controlTypes[controlType].other_properties) {
          _.each(controlTypes[controlType].other_properties, (value, key) => {
              controlInfo[key] = value
          })
      }

      const row = templateFormData.sections[0].rows[0]

      controlInfo = Object.assign(controlInfo, {
        className: 'col-md-6',
        propName,
        label: colName
      })

      // add to row
      row.controls.push(controlInfo)

      ref
        .child(`widgetsData/dataGrid/${gridId}/rowEditorFieldsForm`)
        .set(JSON.stringify(templateFormData))
    },
    setAsTemplate(dashKey) {
      _this.root.ref('dashboardsAsTemplate')
        .child(dashKey)
        .set(true)
    },
    removeFromTemplateList(dashKey) {
      _this.root.ref('dashboardsAsTemplate')
        .child(dashKey)
        .remove()
    },
    getTemplateDashboardsList() {
      return new Promise(resolve => {
        _this.root.ref('dashboardsAsTemplate')
          .once('value', (snapshot) => {
            resolve(Object.keys(snapshot.val() || {}))
          })
      })
    },
    getSelectedTemplates() {
      return new Promise(resolve => {
        _this.getRef('selectedTemplates')
          .once('value', snapshot => {
            resolve(Object.keys(snapshot.val() || {}))
          })
      })
    },
    updateSelectedTemplates(templates) {
      return new Promise(resolve => {
        _this.getRef('selectedTemplates')
          .update(templates, () => {
            resolve()
          })
      })
    },
  }
}
